<template>
  <div class="page-wrap">
    <ul>
      <li :class="{ first: !prePage }" class="page-wrap-or" @click="goPrePage">
        <img
          class="page-wrap-or-rotate"
          src="../assets/images/joins/icon_arrow_r.png"
          alt=""
        />
      </li>
      <li
        v-for="(i, index) in showPageBtn"
        :key="index"
        :class="{
          active: i === offset,
          pointer: i,
        }"
        @click="pageOffset(i)"
      >
        <a v-if="i" class="num">{{ i }}</a>
        <a v-else class="num1">···</a>
      </li>
      <li
        :class="{ finally: !nextPage }"
        class="page-wrap-or"
        @click="goNextPage"
      >
        <img src="../assets/images/joins/icon_arrow_r.png" alt="" />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    /**
     * 一共多少条
     */
    num: {
      type: Number,
      default: 0,
    },
    /**
     * 一页多少条
     */
    limit: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    prePage() {
      return this.offset > 1 && this.num
    },
    nextPage() {
      return this.offset < this.totalPage && this.num
    },
    totalPage() {
      return Math.ceil(this.num / this.limit)
    },
    showPageBtn() {
      if (!this.num || !this.limit) return
      const pageNum = this.totalPage
      const index = this.offset
      if (pageNum <= 5) {
        return [...new Array(pageNum)].map((v, i) => i + 1)
      }
      if (index <= 2) {
        return [1, 2, 3, 0, pageNum]
      }
      if (index >= pageNum - 1) {
        return [1, 0, pageNum - 2, pageNum - 1, pageNum]
      }
      if (index === 3) {
        return [1, 2, 3, 4, 0, pageNum]
      }
      if (index === pageNum - 2) {
        return [1, 0, pageNum - 3, pageNum - 2, pageNum - 1, pageNum]
      }
      return [1, 0, index - 1, index, index + 1, 0, pageNum]
    },
  },
  data() {
    return {
      offset: 1,
    }
  },
  mounted() {
    const { page } = this.$route.query
    if (!page) return
    const num = Number.parseInt(page)
    this.offset = Number.isNaN(num) ? 1 : num
  },
  methods: {
    pageOffset(i) {
      if (i === 0 || i === this.offset) {
        return
      }
      this.offset = i
      this.$emit('page', this.offset)
    },

    goPrePage() {
      this.offset--
      this.$emit('page', this.offset)
    },

    goNextPage() {
      this.offset++
      this.$emit('page', this.offset)
    },
  },
}
</script>
<style lang="less" scoped>
.page-wrap {
  &-or {
    width: 32px;
    height: 32px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dcdee0;
    cursor: pointer;

    &-rotate {
      transform: rotate(180deg);
    }

    img {
      width: 24px;
      height: 24px;
    }
  }

  ul {
    display: flex;
    justify-content: center;
  }
}
li {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  font-size: 14px;
  box-sizing: border-box;
  color: #333;
}
.num {
  cursor: pointer;
  display: block;
  height: 32px;
  width: 32px;
  padding: 0 8px;
  border: 1px solid #dcdee0;
  border-radius: 2px;
  line-height: 32px;
  text-align: center;
  color: #333;
}
a {
  font-size: 14px;
}
.num1 {
  display: block;
  height: 32px;
  width: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 2px;
  border: 1px solid #dcdee0;
}
.page-wrap-or:hover,
.num:hover {
  color: #fff;
  background-color: #cd3324;
  border: 1px solid #cd3324;

  img {
    filter: grayscale(100%) brightness(100);
  }
}
.active .num {
  color: #fff;
  background-color: #cd3324;
  border: 1px solid #cd3324;
}
.first,
.finally {
  pointer-events: none;
  opacity: 0.4;
}
</style>
